module.exports = __webpack_public_path__ + "img/1573234896.29b0894c.jpg";